<template>
    <div>
        <h4 class="text-center thank-you-heading">
            Scan QR
        </h4>
        <p
                class="text-center paragraph"
                style="padding: 0px icon-customer-profil30px"
        >
            Please scan the QR code from your authenticator app
        </p>
        <div style="text-align: -webkit-center;">
            <img :src="data.qrCodeUrl" alt="Scan this QR code with Google Authenticator">
            <hr>
            <p
                    class="text-center paragraph"
                    style="padding: 0px icon-customer-profil30px"
            >
                or copy the code manually
            </p>
            <div class="disable-clipboard">
            <b-form-input
                    id="secret"
                    v-model="data.code"
                    type="text"
                    readonly="true"
                    data-vv-name="apiKey"
                    class="disable-input input-elipsis"
            >
            </b-form-input>
            <i
                    v-b-tooltip.hover
                    class="icon-copy has-icon"
                    title="COPY SECRET KEY"
                    @click="copyApiKey()"
            ></i>
            </div>
            <!--<p>{{data.code}}</p>-->
        </div>
        <hr>
        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
        <b-button
              type="button"
              variant="primary"
              class="primary-add-btn"
              :class="loading ? 'disabled' : ''"
              :disabled="loading"
              @click="generateCode"
          >
              <span class="btn-text">
                  Generate New
                  </span>
          </b-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'

    export default {
        components: {
        },

        props: {
            data: { type: Object },
            heading:{type:String},
        },
        data() {
            return {
                otpCode: '',
                responseData: '',
                isError: '',
            }
        },

        /*
      |--------------------------------------------------------------------------
      | Component > computed
      |--------------------------------------------------------------------------
      */
        computed: {
            ...mapGetters(['loading']),
        }, // End of Component > methods

        /*
      |--------------------------------------------------------------------------
      | Component > mounted
      |--------------------------------------------------------------------------
      */

        mounted() {

        },
        methods: {
            copyApiKey() {
                var copyApiText = document.getElementById('secret')
                copyApiText.select()
                copyApiText.setSelectionRange(0, 99999)
                document.execCommand('copy')
                this.$toasted.show('Secret key has been copied!', {
                    duration: 2000,
                    type: ['success'],
                })
            },
            generateCode()
            {
                this.$emit('generateNew','app',"true")
            }
        },
    }
</script>
<style scoped>
    p {
        margin: 0;
        font-size: 16px;
        padding: 0px 20px;
    }
    .icon-tick-with-circle {
        color: green;
        font-size: 30px;
        cursor: pointer;
    }
    .icon-copy{
        right: 30px !important;
        bottom: 110px !important;
        top: unset !important;
    }
</style>
